<template>
  <div>
    <ca-row>
      <ca-col>
        <ca-heading text="Impressão de Relatórios e Documentos" />
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col>
        <ca-input v-model="search" placeholder="Pesquisar..."></ca-input>
      </ca-col>
    </ca-row>

    <ca-loader v-if="showLoading"></ca-loader>
    <ca-row v-else>
      <ca-col>
        <report-center-table :reports="reports" />
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import ReportCenterTable from './components/report-center-table/ReportCenterTable.vue';
import { getReports } from './reportCenterService';

export default {
  name: 'ReportCenterPage',
  components: {
    ReportCenterTable,
  },
  data() {
    return {
      search: '',
      reports: getReports(),
      debounce: null,
      showLoading: false,
    };
  },
  watch: {
    search() {
      this.getReports();
    },
  },
  methods: {
    getReports() {
      this.showLoading = true;
      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {
        this.reports = getReports(this.search);
        this.showLoading = false;
      }, 300);
    },
  },
};
</script>
